
const getLocation = (data: [],parent: any, level:string) => {
    return data.filter((item:any)=>item?.parent === parent && item?.geo_definition?.node_name === level);
  }
  

  
  export default getLocation;